//=> Import React
import React, { useEffect } from 'react'

//=> Import plugin
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Link } from 'gatsby';

//=> Import Style
import {
  paginationSelect,
  label,
  paginationContainer,
  pagination
} from './styles.module.scss'


const PaginationSelect = ({ changePage, page, productsByPage = "16", setProductsByPage, currentPage }) => {

  // Lors du premier rendu, page = null
  // L'attribut count du composant pagination attend un number
  if (!page) page = 1

  // Change page to display
  const onChangePage = (_, page) => {
    changePage(page)
  }

  const onChangeSelect = (e) => {

    setProductsByPage(e.target.value)
  }

  /* Quand on change le nombre de produit à afficher, si on réduit le nombre de page et que la page sur laquelle l'on se trouvait 
     est supérieur au nombre total de page, 
     la page affiché sera la page max du nombre de page total.
     Ex => je suis sur la page 7 mais je réduit le nombre de page total de 7 à 4.
  */
  // La page affiché sera la 4
  useEffect(() => {
    if (currentPage > page) {
      onChangePage(page)
    }
  }, [productsByPage, page])




  return (
    <div className={paginationContainer}>
      <select className={paginationSelect} id="numberByPage" value={productsByPage} onChange={onChangeSelect}>
        <option value="16">16</option>
        <option value="32">32</option>
        <option value="64">64</option>
        <option value="128">128</option>

      </select>
      <Stack spacing={2} className={pagination}>
        <Link to="#title"><Pagination count={page} defaultPage={1} variant="outlined" onChange={onChangePage} /></Link>
      </Stack>
    </div>

  )
}






export default PaginationSelect